import script from "./ClientStories.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientStories.vue?vue&type=script&setup=true&lang=js"

import "./ClientStories.vue?vue&type=style&index=0&id=2ceee104&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ceee104"]])

export default __exports__